import { apolloClient, apolloClientA } from '~/apollo'
// import { Message } from 'element-ui'

/**
 * @param {String} method 执行方法，值为query/mutate/subscribe
 * @param {String} query GraphQL 文档
 * @param {Object} variables 请求参数
 * @param {String} graphqlType 默认为default，使用graphql客户端
 * @returns 
 */

const apolloRequest = (method, query, variables, graphqlType = 'default') => {
  const client = graphqlType === 'go' ? apolloClientA : apolloClient
  return new Promise(async (resolve, reject) => {
    try {
      const params = {
        [method == 'mutate' ? 'mutation' : 'query']: query || '',
        variables,
        fetchPolicy: 'no-cache' // 不用缓存
      }
      const res = await client[method](params)
      res.data && resolve(res.data)
    } catch (err) {
      // Message.error(err.message)
      reject(err)
    }
  })
}

export default apolloRequest
